"use client";

import { MessagesSquare } from "lucide-react";
import { useTranslations } from "next-intl";

import { cn } from "@/lib/utils";

/**
 * `EX-IAC01`: the "Interactive" tag beside an interactive problem's title, on
 * its page, in the library and on a contest's problem list, as the
 * contestant board draws it: indigo, so it reads apart from the run-twice
 * tag's accent. Rendered only for an interactive problem.
 */
export function InteractiveTag({ className, size = "md" }: { className?: string; size?: "sm" | "md" }) {
  const t = useTranslations("judge.interactive");
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border border-indigo-200 bg-indigo-50 font-semibold text-indigo-800",
        size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-0.5 text-xs",
        className,
      )}
      title={t("tagTitle")}
      data-testid="interactive-tag"
    >
      <MessagesSquare className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} aria-hidden />
      {t("tag")}
    </span>
  );
}
